import styled from 'styled-components';
import { PRIMARY_COLOR } from './../constants/color';
import BackgroundLoginImage from './../assets/backgroundimages/Backdrop.png'
import BackgroundLoginLogo from './../assets/backgroundimages/logo.png'
// import CarouselImg1 from '../assets/images/Carousel-Img1.png'
import CarouselImg1 from '../assets/images/UN0515242-edited.jpg'

export const UserAuthenticationWrapper: any = styled.div` 
    background: ${PRIMARY_COLOR};
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 1128px;
    min-height: 100vh;
    margin: 0;

    [class*="MuiFormLabel-asterisk-"]{
        color: #cc0000;
    }
    div > label > span{
        color: #cc0000;
    }

    .userForm{
        width: 435px;
        // height: 492px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25);
        // margin: 114px auto;
        margin: 25% auto;
        padding: 15px 0px;
        min-height: 400px;
        position: relative;
    }

    .loginTitleSection {
        position: relative;
        text-align: center; 
    }
    .loginTitleSection .backButton{
        position: absolute;
        left: 5px;
        top: -5px;
    }

    .loginTitle{
        font-style: normal;
        font-weight: bold;
        line-height: normal;
        font-size: 24px;
        color: ${PRIMARY_COLOR};
        padding: 25px;
    }

    .loginSubTitle{
        font-style: normal;
        line-height: normal;
        font-size: 14px;
        color: #cc0000;
        padding: 5px;
    }

    .registerTitle{
        font-style: normal;
        font-weight: bold;
        line-height: normal;
        font-size: 24px;
        color: ${PRIMARY_COLOR};
        // padding: 15px 0 0;
        display: inline-block;
    }

    .userForm .formControl{
        margin: 5px 0px;
    }
    
    .loginType{
        background: white;
        box-shadow: none;
        border: none;
        padding: 0 24px;
    }

    .userForm header{
        box-shadow: none;
    }

    form.loginForm>div {
        margin-top: 0px;
        margin-bottom: 16px;
    }

    .loginBtn {
        width: 120px;
        height: 40px;
        display: block;
        margin: 20px auto;
        background-color: #000;
        color: #fff;
        text-transform: initial;
    }
    .loginBtn:hover{
        background-color: #000;
    }
    .loginBtn >span{
        margin-top: -7px;
    }

    .unicefSignIn{
        width: 120px;
        height: 40px;
        display: block;
        margin: 100px auto 0;
        background-color: #000;
        color: #fff;
        text-transform: initial;
    }
    .unicefSignIn:hover{
        background-color: #000;
    }
    .unicefSignIn >span{
        margin-top: -7px;
    }

    .ChevronRightIcon{
        position: relative;
        top: 6px;
    }

    .alignCenter{
        text-align: center;
    }

    .btn-black{
        background-color: #000;
        color: #ffffff;
        border-color: #000;
        display: block;
        width: auto;
        text-align: center;
        margin: 40px auto;
        text-transform: initial;
    }
    .btn-black >span{
        // margin-top: -7px;
    }
    .btn-black:hover{
        background-color: #000;
        color: #ffffff;
    }
    .loginContentSection{
        padding: 25px 24px;
    }
    .loginLink{
        text-align: center;
        margin: 0 auto;
        display: block;
    }
    .loginGoToLink{
        text-align: center;
        margin: 0 auto;
        display: block;
        position: absolute;
        bottom: 25px;
        left: 40%;
    }
    .loginText-l{
        text-align: center;
        font-size: 18px;
        line-height: 22px;
        padding: 15px 0px;
        color: #000;
    }
   
    .loginText-l span{
        display: block;
        font-size: 18px;
        line-height: 22px;
    }

    .loginText-s{
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        padding: 15px 0px;
        color: #000;
    }

    .unciefNotice{
        width: 153px;
        font-size: 14px;
        text-align: center;
        margin: 10px auto;
        line-height: 1;
        color: #C4C4C4;
    }

    .registerBtn {
        width: 155px;
        height: 40px;
        display: block;
        margin: 20px auto;
        background-color: ${PRIMARY_COLOR};
        color: #fff;
        text-transform: initial;
    }
    .registerBtn:hover{
        background-color: ${PRIMARY_COLOR};
    }
    .registerBtn >span{
        margin-top: -7px;
    }

    .registerForm .registerBtn {
        width: 120px;
        height: 40px;
        display: block;
        margin: 10px auto;
        background: black;
    }

    .forgotPassword{
        color: ${PRIMARY_COLOR};
        display: block;
        margin: 10px auto;    
        text-align: center;
        text-decoration: none;
    }

    .registerForm{
        padding: 0 24px;
    }

    //Page Error
    .errorMessage{
        color: #cc0000;
        margin-top: 5px;
        font-size: 14px !important;
        text-align: left;
    }
    //Page Error

    .successMessage{
        color: #1EB911;
        margin-top: 5px;
        font-size: 14px !important;
        text-align: left;
    }

    // .backgroundLoginImage{       
    //     background-image: url(${BackgroundLoginImage});
    //     background-repeat: no-repeat;
    //     background-size: cover;       
    //     width: 100%;
    //     height: 100%;
    //     position: fixed;
    //     background-position: center center;
    //     top: 0 !important;
    //     left: 0 !important;
    //     padding: 0px;
    //     margin: 0px;
    // }

    .backgroundLoginLogo{
        background-image: url(${BackgroundLoginLogo});
        background-repeat: no-repeat;
        background-size: auto;       
        width: 100%;
        height: 100%;
        position: fixed;
        background-position: 36% 25%;
        top: 0 !important;
        left: 0 !important;
        padding: 0px;
        margin: 0px;
    }

    .login-carousel{
        width: 100%;
        position: absolute;
        width: 75%;
        height: 100%;
        position: fixed;
        background-position: center center;
        top: 0 !important;
        /* left: 0 !important; */
        padding: 0px;
        margin: 0px;
        right: 0px;
        bottom: 0px;
    }
    .backgroundLoginImage {
        /* background-image: url(/static/media/Backdrop.e18c5c1d.png); */
        background-repeat: no-repeat;
        background-size: cover;
        width: 25%;
        height: 100%;
        position: fixed;
        background-position: center center;
        top: 0 !important;
        left: 0 !important;
        padding: 0px;
        margin: 0px;
        background-color: #0099ff;
    }

    .userForm {
        position: absolute;
        z-index: 99;
        margin: 6% auto;
        left: 15%;     
        min-height: 450px;   
    }
    .backgroundLoginLogo{
        background-position: 10% 24%;
    }
    // .login-carousel-bg1{
    //     background-image: url(${CarouselImg1});
    //     /* Full height */
    //     height: 100%; 
    //     /* Center and scale the image nicely */
    //     background-position: center;
    //     background-repeat: no-repeat;
    //     background-size: cover;
    // }
    .login-carousel-bg{
        /* Full height */
        height: 100%; 
        /* Center and scale the image nicely */
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .login-carousel-bg1{
        background-image: url(${CarouselImg1});
        background-position: 25% 50%;
    }

    .carousel.carousel-slider{
        height: 100%;
    }
    .carousel .slider-wrapper{
        height: 100%;
    }
    .carousel .slider-wrapper.axis-horizontal .slider{
        height: 100%;
    }

    .datauser-checkbox > label > span{
        color: #0000008a;
    }
    

    .captcha-wrapper{
        padding: 10px 0px;
        margin: 0 auto;
        text-align: center;
        width: 80%;
    }

`;


// WEBPACK FOOTER //
// ./src/styles/login.tsx